import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyAznmc7VW5st-6cpLLsDfvlZ_YHmtkr0dI',
  authDomain: 'magnetlive3.firebaseapp.com',
  databaseURL:
    'https://magnetlive3-317fd.europe-west1.firebasedatabase.app/',
  projectId: 'magnetlive3',
  storageBucket: 'magnetlive3.appspot.com',
  messagingSenderId: '544101773540',
  appId: '1:544101773540:web:7b6e1d3691032da7c73cf1',
  measurementId: 'G-Z3LFV6RMQQ',
};

firebase.initializeApp(config);

let auth = firebase.auth;
let db = firebase.firestore();

const database = firebase.database();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;
const rtdbTimestamp = firebase.database.ServerValue.TIMESTAMP;

let rtdb = firebase.database();

// lokalde emulatore yönlendir
// if (window.location.hostname === 'localhost') {
//   db.settings({
//     host: 'localhost:1339',
//     ssl: false,
//   });
//   database.useEmulator('localhost', 9002);
//   // auth.useEmulator('http://localhost:5000');
// }

export { auth, db, database, timestamp, rtdbTimestamp, rtdb };
